import { Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { IconCircleX } from "@tabler/icons-react";
import { IconWriting, IconX } from "@tabler/icons-react";
import React, { forwardRef, useEffect, useState, } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
    clearReportGenerationList,
    getReportsName,
    reportGenerationData
} from "store/app/report-management/report-generations/actions";
import { unionBy } from 'lodash';
import VWDropdown from "components/dropdown";

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const GenerateReport = (props) => {

    const { open, onClose, reportData } = props;
    const [errors, setErrors] = useState();
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (reportData) {
            setFilter(reportData);
        }
        else {
            setFilter();
        }
    }, [open])

    //--------------------Formula---------------------------
    const [formulaOptions, setFormulaOptions] = useState([]);

    const loadFormulaOption = (filter, page, pageSize) => {
        return props.getReportsName(filter, page, pageSize)
    }

    const validateOnDate = (date, name) => {
        const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;
        setFilter({
            ...filter,
            [name]: formattedDate,
        });
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleReportName = (option) => {
        setFilter({
            ...filter,
            reportname: option,
            formula: option?.formula
        })
        setErrors({
            ...errors,
            reportname: null
        })
    }

    const handleGenerateReport = (e) => {
        e.preventDefault();
        const { reportname, fromdate, todate } = filter || {};
        const { label } = reportname || {};
        let currentErrors = {};

        if (!label && !label?.trim()) {
            currentErrors.reportname = "Formula name is required";
        }
        if (fromdate) {
            if (fromdate === "Invalid date") {
                currentErrors.fromdate = "From date is invalid";
            }
            if (!todate) {
                currentErrors.todate = "To date is required";
            }
        }
        if (todate) {
            if (todate === "Invalid date") {
                currentErrors.todate = "To date is invalid";
            }
            if (!fromdate) {
                currentErrors.fromdate = "From date is required";
            }
        }
        setErrors(currentErrors);
        if (Object.keys(currentErrors).length === 0) {
            // props.setPage();
            props.reportGenerationData(filter);
            onClose();
        }
    }

    const handleCancel = (e) => {
        e.preventDefault();
        props.reportGenerationData();
        props.clearReportGenerationList();
        setFilter();
        onClose();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Generate Report
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} columnGap={1} direction="column">
                                            <Grid item>
                                                <VWDropdown
                                                    label="Formula Name"
                                                    name="reportname"
                                                    multiple={false}
                                                    autoFocus={true}
                                                    // disablePortal={true}
                                                    getOptions={loadFormulaOption}
                                                    onSelect={handleReportName}
                                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    selectedOption={filter?.reportname}
                                                    options={formulaOptions}
                                                    setOptions={(formulaOptions) => {
                                                        setFormulaOptions((prev) => unionBy(prev, formulaOptions, "value"));
                                                    }}
                                                    isRequired={true}
                                                    error={errors?.reportname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="From Date"
                                                        onChange={(date) => validateOnDate(date, "fromdate")}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.fromdate ? moment.utc(filter.fromdate, "YYYY-MM-DD") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                error: errors?.fromdate,
                                                                helperText: errors?.fromdate
                                                            },
                                                            field: { clearable: true },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="To Date"
                                                        onChange={(date) => validateOnDate(date, "todate")}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.todate ? moment.utc(filter.todate, "YYYY-MM-DD") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                error: errors?.todate,
                                                                helperText: errors?.todate
                                                            },
                                                            field: { clearable: true },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleGenerateReport}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconWriting />}
                                            >
                                                Generate Report
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleCancel}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )}
            </Dialog >
        </>
    )
}

const mapStateToProps = (state) => ({
    reportData: state.reportGeneration.reportGeneratedData,
})
const mapDispatchToProps = (dispatch) => ({
    getReportsName: (filter, page, pageSize) => dispatch(getReportsName(filter, page, pageSize)),
    reportGenerationData: (reportData) => dispatch(reportGenerationData(reportData)),
    clearReportGenerationList: () => dispatch(clearReportGenerationList()),
})

export default connect(mapStateToProps, mapDispatchToProps)(GenerateReport);